<template>
  <div>
    <Navbar :token="token" :isMobile="isMobile" />
    <Sidenav :isMobile="isMobile" :isAdmin="isAdmin" :token="token"></Sidenav>
    <div class="content d-flex flex-column justify-content-between">
      <ContentHeader :page_name="routeName" :token="token" />
      <div class="mb-auto">
        <router-view
          :key="$route.fullPath"
          :isMobile="isMobile"
          :isAdmin="isAdmin"
          :token="token"
        ></router-view>
      </div>
      <div class="content-footer py-4 bg-white">
        <div class="content-width">
          <div class="d-flex justify-content-between">
            <small class="text-platform_sub"
              >© {{ new Date().getFullYear() }} Quarter Car
              Part.版權所有。</small
            >
            <small class="text-platform_sub">v{{ version }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.content {
  width: calc(100% - #{$sidenav_width});
  min-height: 100vh;
  margin-left: auto;
  padding-top: $navbar_height;
  background: #f2f2f2;
  @include media-breakpoint-down(sm) {
    padding-top: $navbar_height-sm;
    width: 100%;
  }
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: $cms_main;
}
</style>

<script>
import Sidenav from "@/components/cms/Sidenav.vue";
import Navbar from "@/components/cms/Navbar.vue";
import ContentHeader from "@/components/cms/ContentHeader.vue";
import { LoginCms } from "@/assets/api/cms.js";
import { Toast } from "@/plugins/sweetalert2.js";

export default {
  name: "CMS",
  components: {
    Sidenav,
    Navbar,
    ContentHeader
  },
  data() {
    return {
      isMobile: false,
      isAdmin: null,
      token: null,
      routeName: "",
      version: process.env.VUE_APP_VERSION
    };
  },
  created() {
    this.token = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("cms-api_token")
      }
    };
    LoginCms.permission(this.token)
      .then(res => {
        if (res.status <= 201) {
          if (res.data.role[0] == "Admin") {
            localStorage.setItem("isAdmin", 1);
            this.isAdmin = true;
            this.routeName = this.$route.name;
          } else {
            localStorage.setItem("isAdmin", 0);
            this.isAdmin = false;
            this.goToOder();
          }
        } else {
          Toast.fire({
            icon: "error",
            title: "權限讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    goToOder() {
      if (
        this.$route.name == "商品管理" ||
        this.$route.name == "業務區域管理" ||
        this.$route.name == "業務" ||
        this.$route.name == "管理者"
      ) {
        this.$router.push({ name: "訂單管理" });
      }
      this.routeName = this.$route.name;
    },
    resizeWindowWidth() {
      if (document.querySelector("html").offsetWidth < 767.98) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
  },
  mounted() {
    this.resizeWindowWidth();
    window.addEventListener("resize", () =>
      setTimeout(() => {
        this.resizeWindowWidth();
      }, 100)
    );
  },
  updated() {
    this.routeName = this.$route.name;
  }
};
</script>
